export default __webpack_public_path__ + "static/media/Group 3203@2x.598cab69.png";